import type { ArticleBlock } from "../../../services/educationService";
import { ArticleCallout } from "./ArticleCallout";
import { ArticleHeading } from "./ArticleHeading";
import { ArticleImage } from "./ArticleImage";
import { ArticleParagraph } from "./ArticleParagraph";
import { ArticleSteps } from "./ArticleSteps";

export function BlockRenderer({ blocks }: { blocks: ArticleBlock[] }) {
	return (
		<>
			{blocks.map((block, i) => {
				switch (block.type) {
					case "paragraph":
						return <ArticleParagraph key={i} block={block} />;
					case "heading":
						return <ArticleHeading key={i} block={block} />;
					case "callout":
						return <ArticleCallout key={i} block={block} />;
					case "process-steps":
						return <ArticleSteps key={i} block={block} />;
					case "image":
						return <ArticleImage key={i} block={block} />;
					default:
						return null;
				}
			})}
		</>
	);
}
